import styled from "styled-components";

export const CharityWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 60px auto 60px;
  padding: 0 var(--container-pad);
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 600px) {
    margin: 32px auto 40px;
  }
`;

export const HeroBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 999px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--color-text);
  max-width: 900px;
`;

export const Accent = styled.div`
  width: 56px;
  height: 4px;
  background: var(--color-primary);
  border-radius: 999px;
`;

export const Card = styled.section`
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 36px 44px;
  box-shadow: var(--shadow-sm);

  @media (max-width: 768px) {
    padding: 26px 22px;
  }
`;

export const CardTitle = styled.h2`
  margin: 0 0 18px;
  font-size: clamp(20px, 2.4vw, 26px);
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: "";
    width: 6px;
    height: 22px;
    background: var(--color-primary);
    border-radius: 999px;
  }
`;

export const IntroText = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.7;
  color: var(--color-text);
  margin: 0 0 18px;

  strong {
    color: var(--color-primary);
    font-weight: 700;
  }
`;

export const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-text);

  &::before {
    content: "";
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-top: 9px;
    background: var(--color-primary);
    border-radius: 50%;
  }
`;

export const DiscountsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DiscountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-soft);
  transition: var(--transition);

  &:hover {
    border-color: var(--color-primary-light);
    background: var(--color-primary-soft);
  }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const DiscountSchool = styled.a`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-primary);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: var(--transition);

  &:hover {
    border-color: var(--color-primary);
  }
`;

export const DiscountValue = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: var(--color-primary);
  color: white;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.4px;
  border-radius: 999px;
  flex-shrink: 0;
`;

export const SectionTitle = styled.h2`
  margin: 8px 0 0;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.3px;
  text-align: center;
`;

export const CharityGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;

  a {
    text-decoration: none;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const EventCard = styled.div`
  width: 100%;
  text-decoration: none !important;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
  height: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-md);
    border-color: var(--color-primary-light);
  }
`;

export const EventImageWrap = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  background: var(--color-bg-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
`;

export const EventImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const EventBody = styled.div`
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const EventTitle = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const EventCTA = styled.div`
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-primary);
  letter-spacing: 0.3px;

  svg {
    width: 12px;
    height: 9px;
    transition: transform var(--transition);
  }

  ${EventCard}:hover & svg {
    transform: translateX(4px);
  }
`;

export const CharityContaoner = styled.div``;
export const MainText = IntroText;
export const SecondText = CardTitle;
export const CharityText = IntroText;
